/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import './InputDropdown.css'

import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { noop } from 'utils'

import Box from '@mui/material/Box'
import ClickAwayListener from '@mui/material/ClickAwayListener'

const InputDropdown = ({ label, onChange, options, selectedValue }) => {
  const [isDropdownExpanded, setIsDropdownExpanded] = useState(false)
  const selectedOption = options.find(option => option.value === selectedValue)
  const onDropdownChange = option => () => {
    setIsDropdownExpanded(false)
    onChange(option)
  }
  const toggleDropdown = () => setIsDropdownExpanded(!isDropdownExpanded)

  return (
    <ClickAwayListener onClickAway={() => setIsDropdownExpanded(false)}>
      <div className="dropdown-wrapper">
        {label && (
          <Box className="dropdown-label" onClick={toggleDropdown}>
            {label}
          </Box>
        )}
        <Box
          className={classNames('dropdown-header', 'cursor-pointer', { 'is-expanded': isDropdownExpanded })}
          onClick={toggleDropdown}
        >
          <Box className="dropdown-header-title" onClick={toggleDropdown}>
            {selectedOption && (
              <>
                {selectedOption.icon}
                {selectedOption.label}
              </>
            )}
          </Box>
          <Box className={classNames('dropdown-open-icon', { reverse: isDropdownExpanded })} onClick={toggleDropdown} />
        </Box>

        {isDropdownExpanded && (
          <ul className="dropdown-list">
            {options
              .filter(option => option.value !== selectedValue)
              .map(option => (
                <li className="cursor-pointer" key={option.label} onClick={onDropdownChange(option.value)}>
                  {option.icon}
                  {option.label}
                </li>
              ))}
          </ul>
        )}
      </div>
    </ClickAwayListener>
  )
}

InputDropdown.defaultProps = {
  onChange: noop,
}

InputDropdown.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      label: PropTypes.string,
      value: PropTypes.any,
    }),
  ),
  // eslint-disable-next-line react/forbid-prop-types
  selectedValue: PropTypes.any,
}

export default InputDropdown
